import React, { useEffect, useState } from 'react';
import BarChart from './BarChart';
import useHttp from '../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';
import Skeleton from '../../../Shared/Skeleton';

const HistogramSection = ({ packType, filterdata }) => {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [chargingChartData, setChargingChartData] = useState({ histogramData: [], percentage: null })
  const [chargingState, setChargingState] = useState("charging")
  const [sensorData, setSensorData] = useState({ data: [], percentage20_30: null, percentage30_40: null, status: "" })
  const [sensorName, setSensorName] = useState("Sensor_1_temp")
  const [currentChartLoader, setCurrentChartLoader] = useState(false)
  const [temperatureChartLoader, setTemperatureChart] = useState(false)


  useEffect(() => {
    setCurrentChartLoader(true)
    let reqObj = {
      ...filterdata,
      fieldName: `${packType}_Pack_Curr_Value`,
      mode: chargingState
    }

    fetchData(
      {
        url: API_URL_MAIN + `battery_digital_twin/histogram_current_new`,
        body: { filterdata: reqObj },
      },
      (data) => {
        if (data) {
          setChargingChartData(data)
        } else {
          setChargingChartData({ histogramData: [], percentage: null })
        }
        setCurrentChartLoader(false)
      }
    );
  }, [filterdata, packType, chargingState])


  useEffect(() => {
    setTemperatureChart(true)
    let reqObj = {
      ...filterdata,
      fieldName: `${packType}_${sensorName}`
    }
    let url = sensorName?.includes("Sensor") ? "histogram_sensors" : "histogram_coolant"
    fetchData(
      {
        url: API_URL_MAIN + `battery_digital_twin/${url}`,
        body: { filterdata: reqObj },
      },
      (data) => {
        if (data) {
          setSensorData(prev => ({ ...prev, data: data?.histogramData, percentage20_30: data?.percentage?.["20_to_30"], percentage30_40: data?.percentage?.["30_to_40"], status: data?.thermalStress }))
        } else {
          setSensorData({ data: [], percentage20_30: null, percentage30_40: null, status: "" })
        }
        setTemperatureChart(false)
      }
    );
  }, [filterdata, packType, sensorName])

  const noteGenerator = (noteGenerator) => {
    return (
      <li className="text-start">
        {
          noteGenerator.includes("charging") ?
            <><b>Charging:</b> <b>{chargingChartData?.percentage}%</b> of charging took place at less than <b>0.13C</b> Rating.</>
            : noteGenerator.includes("discharge") ?
              <><b>Discharging:</b> <b>{chargingChartData?.percentage}%</b>  of discharging took place greater than <b>-0.13C</b> Rating. Driver inputs are normal.​</>
              : <><b>Charging & Discharging:</b> <b>{chargingChartData?.percentage}%</b> of current flow happen between <b>-0.13C</b> and <b>0.13C</b> Rating.</>
        }
      </li>
    )
  }

  return (
    <div className="row g-3 mb-4 equal-cols">
      {/* left side histogram */}
      <div className="col-12 col-md-6 ps-0">
        <div className="card p-2 flex-grow-1">
          <div className="row">
            <div className="col d-flex justify-content-end">
              <div className="col-12 col-sm-6 col-md-5  text-center my-2">
                <select
                  className="form-select form-select-sm"
                  value={chargingState}
                  onChange={(e) => setChargingState(e.target.value)}
                >
                  <option value="charging">Charging</option>
                  <option value="discharge">Discharging</option>
                  <option value="ChargePlusDischarge">Charging + Discharging</option>
                </select>
              </div>
            </div>
          </div>
          <BarChart data={chargingChartData?.histogramData} yLabel='Normalized Distribution' xLabel="Current (A)" isLoading={currentChartLoader} />
          <ol className="small text-secondary mb-2 ps-3 ms-4 text-start">
            {
              currentChartLoader
                ? <><Skeleton width="90%" height="10px" /></>
                : noteGenerator(chargingState)}
          </ol>
        </div>
      </div>
      {/* Right side histogram */}
      <div className="col-12 col-md-6 pr-0">
        <div className="card p-2 flex-grow-1">
          <div className="row">
            <div className="col d-flex justify-content-end">
              <div className="col-12 col-sm-6 col-md-5 text-center my-2">
                <select
                  className="form-select form-select-sm"
                  value={sensorName}
                  onChange={(e) => setSensorName(e.target.value)}
                >
                  <option value="Sensor_1_temp">Sensor_1</option>
                  <option value="Sensor_2_temp">Sensor_2</option>
                  <option value="Sensor_3_temp">Sensor_3</option>
                  <option value="Sensor_4_temp">Sensor_4</option>
                  <option value="Sensor_5_temp">Sensor_5</option>
                  <option value="Sensor_6_temp">Sensor_6</option>
                  <option value="Sensor_7_temp">Sensor_7</option>
                  <option value="Sensor_8_temp">Sensor_8</option>
                  <option value="Sensor_9_temp">Sensor_9</option>
                  <option value="Sensor_10_temp">Sensor_10</option>
                  <option value="Sensor_11_temp">Sensor_11</option>
                  <option value="Sensor_12_temp">Sensor_12</option>
                  <option value="Coolant_Temp_In">Coolant_Temp_In</option>
                  <option value="Coolant_Temp_Out">Coolant_Temp_Out</option>
                  <option value="Coolant_In_Out_diff">Coolant_In_Out_diff</option>
                </select>
              </div>
            </div>
          </div>
          <BarChart data={sensorData.data} yLabel='Normalized Distribution' xLabel={sensorName.includes("Sensor") ? "Temperature (°C)" : "Coolant"} isLoading={temperatureChartLoader} />
          <ol className={`small text-secondary mb-2 ps-3 ms-4 text-start ${!sensorName?.includes("Sensor") ? "d-none" : ""}`}>
            {
              temperatureChartLoader ?
                <>
                  <Skeleton width="90%" height="10px" />
                  <Skeleton width="30%" height="10px" />
                </>
                : <li className="text-start">
                  <><b>{sensorName?.replace(/Sensor_(\d+)_temp/, "Sensor $1")}</b> was operated at <b>20-30deg</b> for <b>{sensorData?.percentage20_30}%</b> and <b>30-40deg</b> for <b>{sensorData?.percentage30_40}%</b> of operating time.
                    <br />Thermal stress is <b>{sensorData?.status}</b>.</>
                </li>
            }
          </ol>
        </div>
      </div>
    </div>
  );
}

export default HistogramSection;
